// App.tsx
import React, { useState, useEffect, useRef } from 'react';

const OneVideoCall: React.FC = () => {
  const [localStream, setLocalStream] = useState<MediaStream | null>(null);
  const [remoteStream, setRemoteStream] = useState<MediaStream | null>(null);
  const [isCallStarted, setIsCallStarted] = useState<boolean>(false);
  const [isTutorJoined, setIsTutorJoined] = useState<boolean>(false);
  const [isStudentJoined, setIsStudentJoined] = useState<boolean>(false);
  const localVideoRef = useRef<HTMLVideoElement>(null);
  const remoteVideoRef = useRef<HTMLVideoElement>(null);
  const pc1 = useRef<RTCPeerConnection>(new RTCPeerConnection());
  const pc2 = useRef<RTCPeerConnection>(new RTCPeerConnection());

  useEffect(() => {
    const getUserMedia = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        setLocalStream(stream);
        if (localVideoRef.current) {
          localVideoRef.current.srcObject = stream;
        }
      } catch (error) {
        console.error('Error accessing media devices:', error);
      }
    };

    getUserMedia();
  }, []);

  const joinAsTutor = async () => {
    setIsTutorJoined(true);
    await startCall();
  };

  const joinAsStudent = async () => {
    setIsStudentJoined(true);
    await startCall();
  };

  const startCall = async () => {
    if (isTutorJoined && isStudentJoined && localStream) {
      setIsCallStarted(true);

      localStream.getTracks().forEach((track) => {
        pc1.current.addTrack(track, localStream);
      });

      try {
        const offer = await pc1.current.createOffer();
        await pc1.current.setLocalDescription(offer);
        await pc2.current.setRemoteDescription(offer);

        const answer = await pc2.current.createAnswer();
        await pc2.current.setLocalDescription(answer);
        await pc1.current.setRemoteDescription(answer);
      } catch (error) {
        console.error('Error establishing connection:', error);
      }

      pc2.current.ontrack = (event: RTCTrackEvent) => {
        setRemoteStream(event.streams[0]);
      };
    }
  };

  useEffect(() => {
    if (remoteStream && remoteVideoRef.current) {
      remoteVideoRef.current.srcObject = remoteStream;
    }
  }, [remoteStream]);

  return (
    <div className="container mx-auto mt-8">
      <h1 className="text-3xl font-bold mb-4">1-on-1 Video Call</h1>
      <div className="mb-4">
        <video ref={localVideoRef} autoPlay muted className="w-1/2"></video>
        <video ref={remoteVideoRef} autoPlay className="w-1/2"></video>
      </div>
      <div>
        {!isCallStarted && (
          <>
            <button
              onClick={joinAsTutor}
              disabled={isTutorJoined}
              className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-4 ${
                isTutorJoined ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              Join as Tutor
            </button>
            <button
              onClick={joinAsStudent}
              disabled={isStudentJoined}
              className={`bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded ${
                isStudentJoined ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              Join as Student
            </button>
          </>
        )}
      </div>
    </div>
  );
};


export default OneVideoCall;